/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { API_URLS } from "../../shared/constants/constants";
import Base64 from "base-64";
import {
  Typography,
  TextField,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Button,
  DialogContent,
  DialogTitle,
  Dialog,
  Select,
  OutlinedInput,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Markdown from "markdown-to-jsx";
import { Link } from "react-router-dom";
import { Box } from "@mui/system";
import { useState, useEffect, useRef, useContext } from "react";
import {
  getTestDriveDetails,
  getDealersDetails,
  postTestDriveInfo,
} from "./testDriveApiRequest";
import axios from "axios";
import MyContext from "../../shared/components/context/MyContext";
import { v4 } from "uuid";
const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
  "Access-Control-Allow-Headers":
    "Content-Type, Authorization, X-Requested-With",
};
const industry = ["消防", "建筑工程", "油田", "旅居车", "运输", "其他"];
const testDriveWrapper = (testDriveInfo, matches) => css`
  background-image: url(${process.env.REACT_APP_BASEURL}${testDriveInfo});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  padding: ${matches ? "50px 30px 20px 30px" : "50px 100px"};
  justify-content: ${matches ? "flex-start" : "space-between"};
  flex-direction: ${matches ? "column" : "row"};
`;
const appointmentSuccessWrapper = (theme) => css`
  height: 260px;
  margin-top: calc(50vh - 300px);
  padding: 50px 36px 30px 36px;
  background: #1f1f1f;
  .MuiBox-root {
    width: 240px;
    .MuiTypography-root:nth-of-type(1) {
      font-size: 30px;
      font-family: ${theme.typography.MBCORPOS};
      position: relative;
      left: 0px;
    }
    .MuiTypography-root:nth-of-type(2) {
      width: 40px;
      border-bottom: 3px solid;
      margin: 38px 0 24px 0;
    }
    .MuiTypography-root:nth-of-type(3) {
      font-size: 14px;
      margin-bottom: 60px;
    }
    div {
      display: flex;
      justify-content: center;
      .MuiButton-root {
        width: 110px;
        border: 1px solid white;
        color: white;
      }
    }
  }
`;
const formWrapper = (matches) => css`
  display: flex;
  .MuiTypography-root,
  .MuiInputBase-root {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  }
  flex-direction: column;
  width: ${matches ? "100%" : "300px"};
  margin-top: ${matches ? "50px" : "20px"};

  .MuiOutlinedInput-root {
    fieldset {
      border-color: white !important;
    }
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    .MuiSvgIcon-root {
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }
  }

  .MuiSelect-select {
    background: #2f2f2f;
    p {
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }
  }
  .MuiFormControlLabel-root {
    .MuiFormControlLabel-label,
    .MuiSvgIcon-root {
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }
  }
`;
const verificationText = css`
  font-size: 14px;
  color: #2699fb;
  white-space: nowrap;
  cursor: pointer;
`;
const productsWrapper = (selected) => css`
  display: flex;
  margin-bottom: ${selected ? "4px" : "20px"};
  justify-content: space-between;
  .MuiBox-root {
    width: calc(50% - 5px);
    .MuiOutlinedInput-root {
      width: 100%;
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
      svg {
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
      }
    }
  }
`;
const privacyPolicyWrapper = (isCheckedApprovePolicy) => css`
  display: flex;
  align-items: center;
  .MuiTypography-body1 {
    font-size: 14px;
  }
  .MuiFormControlLabel-root {
    .MuiCheckbox-root {
      .MuiSvgIcon-root {
        color: ${isCheckedApprovePolicy ? "default" : "red"};
      }
    }
    .MuiCheckbox-root.Mui-checked {
      .MuiSvgIcon-root {
        color: "default";
      }
    }
  }
`;

const testDriveTitle = (theme, matches) => css`
  font-family: ${theme.typography.MBCORPOS};
  font-size: 42px;
  position: relative;
  left: ${matches ? "0" : "2%"};
  top: ${matches ? "unset" : "8px"};
  margin-top: ${matches ? "0" : "20px"};
`;
const privacyPolicy = css`
  text-decoration: underline;
  cursor: pointer;
`;
const errorWrapper = css`
  padding-left: 14px;
`;
const userNameWrapper = (isLegalUserName) => css`
  margin-bottom: ${isLegalUserName ? "10px" : "-5px"};
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #1f1f1f !important;
    }
  }
`;
const userTelWrapper = (isLegalUserTel) => css`
  margin-bottom: ${isLegalUserTel ? "20px" : "4px"};
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #1f1f1f !important;
    }
  }
`;
const labelWrapper = css`
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  .MuiFormControlLabel-root {
    margin: 0;
    margin-left: -10px;
  }
  .MuiFormControlLabel-root:nth-of-type(2) {
    margin-left: 20px;
  }
`;
const cityRadio = (isSelectedCity) => css`
  margin: 10px 0;
  margin-top: ${isSelectedCity ? "10px" : 0};
  display: flex;
  flex-direction: row;
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;
const verificationCodeWrapper = (isValidationCodeCorrect) => css`
  margin-bottom: ${isValidationCodeCorrect ? "20px" : "4px"};
  .MuiFormHelperText-root {
    color: #d32f2f;
  }
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #1f1f1f !important;
    }
  }
`;
const dealerWrapper = css`
  margin-bottom: 20px;
`;

const dealerListItemWrapper = css`
  display: flex;
  flex-direction: column;
  .MuiBox-root {
    width: 100%;
  }
  .MuiBox-root:nth-of-type(1) {
    display: flex;
    justify-content: space-between;
    .MuiTypography-root:nth-of-type(1) {
      width: 200px;
      white-space: initial;
    }
    .MuiTypography-root:nth-of-type(2) {
      color: #808080;
    }
    .MuiTypography-root {
      font-size: 10px;
    }
  }
`;
const functionality = css`
  margin-right: 5px;
  .MuiTypography-root {
    display: inline;
    padding: 3px 5px;
    border: 1px solid #808080;
    border-radius: 4px;
    font-size: 10px;
    color: #cccccc;
  }
`;
const categoryWrapper = css`
  display: flex;
  justify-content: flex-start;
`;
const privacyPolicyContentWrapper = css`
  img {
    width: 100%;
  }
`;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const MenuProps = {
  PaperProps: {
    style: {
      background: "black",
      maxHeight: 180,
    },
  },
};
const getDealerDistance = (lat1, lng1, lat2, lng2) => {
  var rad1 = ((lat1 || 0) * Math.PI) / 180.0;
  var rad2 = ((lat2 || 0) * Math.PI) / 180.0;
  var a = rad1 - rad2;
  var b = ((lng1 || 0) * Math.PI) / 180.0 - ((lng2 || 0) * Math.PI) / 180.0;
  var r = 6378137;
  var distance =
    r *
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(rad1) * Math.cos(rad2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  return (distance / 1000).toFixed(1);
};
const sortByOrder = (data) => {
  return data?.sort((a, b) => a.attributes.distance - b.attributes.distance);
};
const TestDrive = () => {
  const [testDriveInfo, setTestDriveInfo] = useState();
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || ""
  );
  const [gender, setGender] = useState(
    localStorage.getItem("gender") || "male"
  );
  const [isLegalUserName, setIsLegalUserName] = useState(true);
  const [isSelectedProduct, setIsSelectedProduct] = useState(true);
  const [isSelectedScenario, setIsSelectedScenario] = useState(true);
  const [isSelectedCity, setIsSelectedCity] = useState(true);
  const [userTel, setUserTel] = useState(localStorage.getItem("userTel") || "");
  const [validationCode, setValidationCode] = useState("");
  const [isValidationCodeCorrect, setIsValidationCodeCorrect] = useState(true);
  const [isLegalUserTel, setIsLegalUserTel] = useState(true);
  const [approvePolicy, setApprovePolicy] = useState(false);
  const [isCheckedApprovePolicy, setIsCheckedApprovePolicy] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [dealerList, setDealerList] = useState([]);
  const [currentCityDealers, setCurrentCityDealers] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [isAllowPosition, setIsAllowPosition] = useState(false);
  const [isAppointmentSuccess, setIsAppointmentSuccess] = useState(false);
  const [isAppointmentSubmit, setIsAppointmentSubmit] = useState(false);
  const { carModel } = useContext(MyContext);
  const [products, setProducts] = useState();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const matches = useMediaQuery("(max-width: 415px)");

  useEffect(() => {
    const fetchToken = async () => {
      const configValidate = {
        headers: headers,
      };
      const data = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_JAVAURL}${API_URLS.fetchToken}`,
        data: {
          password: "password",
          username: "daimler-truck",
        },
        config: configValidate,
      });
      setToken(data?.data?.token);
    };
    fetchToken();
  }, []);
  const theme = useTheme();
  useEffect(() => {
    if (carModel) {
      setProducts(carModel[0]?.children[0]?.children.map((i) => i.title));
      setProduct(localStorage.getItem("product") || "");
    }
  }, [carModel]);
  useEffect(() => {
    setScenario(localStorage.getItem("scenario") || "");
    getTestDriveDetails().then((res) => {
      document.title = res?.data?.data?.attributes?.title;
      setTestDriveInfo(res?.data?.data?.attributes);
    });
    getDealers([], 1);
  }, []);
  const getDealers = (currentDealers, nextPage) => {
    getDealersDetails(nextPage).then((response) => {
      if (
        response.data.meta.pagination.total >
        response.data.meta.pagination.page * 100
      ) {
        getDealers(
          [...currentDealers, ...response.data.data],
          response.data.meta.pagination.page + 1
        );
      } else {
        setDealerList([...currentDealers, ...response.data.data]);
        if (localStorage.getItem("city")) {
          setCurrentCityDealers(
            [...currentDealers, ...response.data.data].filter(
              (item) =>
                item.attributes?.city?.data?.attributes?.name ===
                localStorage.getItem("city")
            )
          );
          setCity(localStorage.getItem("city") || "");
          setDealer(localStorage.getItem("dealer") || "");
        } else {
          getLocation([...currentDealers, ...response.data.data]);
        }
        setAllCities([
          ...new Set(
            [...currentDealers, ...response.data.data].map((dealer) => {
              return dealer.attributes.city.data.attributes.name;
            })
          ),
        ]);
      }
    });
  };
  const getLocation = (dealers) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          dealers?.forEach((dealer) => {
            dealer.attributes.distance = getDealerDistance(
              position.coords.latitude,
              position.coords.longitude,
              dealer.attributes.latitude,
              dealer.attributes.longitude
            );
          });
          setDealerList(sortByOrder(dealers));
          var myCity = new window.BMapGL.LocalCity();
          myCity.get((res) => {
            setCity(res.name);
            setCurrentCityDealers(
              sortByOrder(
                dealers.filter(
                  (dealer) =>
                    dealer.attributes.city.data.attributes.name === res.name
                )
              )
            );
          });
          setIsAllowPosition(true);
        },
        function (error) {
          console.log(error);
          setCity("城市");
          dealers?.forEach((dealer) => {
            dealer.attributes.distance = getDealerDistance(
              39.91,
              116.4,
              dealer.attributes.latitude,
              dealer.attributes.longitude
            );
          });
          setDealerList(sortByOrder(dealers));
        },
        { timeout: 5000 }
      );
    } else {
      // your browser/device doesn't support geolocation
    }
  };
  const handleNameChange = (e) => {
    setUserName(e.target.value);
    localStorage.setItem("userName", e.target.value);
  };
  const handleTelChange = (e) => {
    setUserTel(e.target.value);
    localStorage.setItem("userTel", e.target.value);
  };
  const handleCodeChange = (e) => {
    setValidationCode(e.target.value);
  };
  const handleGenderChange = (e) => {
    setGender(e.target.value);
    localStorage.setItem("gender", e.target.value);
  };
  const handleSubmit = async () => {
    setIsLegalUserName(/^[\u4e00-\u9fa5a-zA-Z0-9 ]+$/.test(userName));
    setIsLegalUserTel(/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(userTel));
    setIsSelectedProduct(!!product);
    setIsSelectedScenario(!!scenario);
    setIsSelectedCity(!!city && city !== "城市");
    setIsCheckedApprovePolicy(approvePolicy);
    if (
      /^[\u4e00-\u9fa5a-zA-Z0-9 ]+$/.test(userName) &&
      /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(userTel) &&
      !!product &&
      !!scenario &&
      approvePolicy
    ) {
      setIsLoading(true);
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          ...headers,
        },
      };
      axios
        .post(
          `${process.env.REACT_APP_JAVAURL}${API_URLS.validateOtp}`,
          {
            validationCode: validationCode,
            mobile: Base64.encode(userTel),
          },
          config
        )
        .then((response) => {
          if (response?.data?.success) {
            const postStrapiData = {
              data: {
                userName: userName,
                gender: gender,
                userTel: Base64.encode(userTel),
                scenario: scenario,
                product: product,
                city: city,
                dealer: dealer,
              },
            };
            postTestDriveInfo(postStrapiData)
              .then(() => {
                setIsAppointmentSuccess(true);
                setIsLoading(false);
                localStorage.setItem("userName", "");
                localStorage.setItem("userTel", "");
                localStorage.setItem("scenario", "");
                localStorage.setItem("product", "");
                localStorage.setItem("city", "");
                localStorage.setItem("dealer", "");
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
                setIsAppointmentSuccess(false);
              });
            setIsAppointmentSubmit(true);
          } else {
            setIsLoading(false);
            setIsValidationCodeCorrect(false);
            setIsAppointmentSuccess(false);
          }
        })
        .catch(() => {
          setIsValidationCodeCorrect(false);
          setIsLoading(false);
        });
    }
  };
  const [scenario, setScenario] = useState("");
  const [product, setProduct] = useState("");
  const [city, setCity] = useState("");
  const [dealer, setDealer] = useState("");
  const getStyles = (name, personName, theme) => {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
      fontSize: "14px",
    };
  };
  const handleScenarioChange = (event) => {
    setScenario(event.target.value);
    localStorage.setItem("scenario", event.target.value);
  };
  const handleProductChange = (event) => {
    setProduct(event.target.value);
    localStorage.setItem("product", event.target.value);
  };
  const handleCityChange = (event) => {
    localStorage.setItem("city", event.target.value);
    setCity(event.target.value);
    setDealer("");
    setCurrentCityDealers(
      dealerList.filter(
        (item) =>
          item.attributes.city.data.attributes.name === event.target.value
      )
    );
  };
  const handleDealerChange = (event) => {
    setDealer(event.target.value);
    localStorage.setItem("dealer", event.target.value);
  };
  return (
    <Box
      css={() =>
        testDriveWrapper(
          testDriveInfo?.background?.data?.attributes?.url,
          matches
        )
      }
    >
      <Typography css={(theme) => testDriveTitle(theme, matches)}>
        {testDriveInfo?.title}
      </Typography>
      {isAppointmentSubmit && !isLoading ? (
        <AppointmentResult
          reservationSuccessTitle={testDriveInfo?.reservationSuccessTitle}
          reservationSuccessContent={testDriveInfo?.reservationSuccessContent}
          backToHomeText={testDriveInfo?.backToHomeText}
          reservationFailureTitle={testDriveInfo?.reservationFailureTitle}
          backText={testDriveInfo?.backText}
          isAppointmentSuccess={isAppointmentSuccess}
          setIsAppointmentSubmit={setIsAppointmentSubmit}
        />
      ) : (
        <Box css={() => formWrapper(matches)}>
          <TextField
            autoComplete="off"
            error={!isLegalUserName}
            id="user-name"
            placeholder={testDriveInfo?.namePlaceholder}
            onChange={handleNameChange}
            size="small"
            helperText={isLegalUserName ? "" : "请输入您的中文或英文姓名"}
            value={userName}
            css={() => userNameWrapper(isLegalUserName)}
          />
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              css={labelWrapper}
              onChange={handleGenderChange}
              value={gender}
            >
              <FormControlLabel
                value="male"
                control={<Radio color="default" />}
                label={testDriveInfo?.maleText}
              />
              <FormControlLabel
                value="female"
                control={<Radio color="default" />}
                label={testDriveInfo?.femaleText}
              />
            </RadioGroup>
          </FormControl>
          <TextField
            error={!isLegalUserTel}
            autoComplete="off"
            id="user-tel"
            placeholder={testDriveInfo?.telPlaceholder}
            size="small"
            onChange={handleTelChange}
            value={userTel}
            helperText={
              isLegalUserTel ? "" : "请输入中国大陆手机号码（11位数字）"
            }
            css={() => userTelWrapper(isLegalUserTel)}
          />
          <TextField
            autoComplete="off"
            id="verification-code"
            placeholder={testDriveInfo?.validationPlaceholder}
            onChange={handleCodeChange}
            size="small"
            css={() => verificationCodeWrapper(isValidationCodeCorrect)}
            helperText={isValidationCodeCorrect ? "" : "请输入正确的验证码"}
            InputProps={{
              endAdornment: (
                <TimeCountdown
                  setIsLegalUserTel={setIsLegalUserTel}
                  sendValidationCode={testDriveInfo?.sendValidationCode}
                  token={token}
                  userTel={userTel}
                />
              ),
            }}
          />
          <Box
            css={() =>
              productsWrapper(!isSelectedScenario || !isSelectedProduct)
            }
          >
            <Box>
              <Select
                displayEmpty
                value={scenario}
                size="small"
                onChange={handleScenarioChange}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <Typography>
                        {testDriveInfo?.AppScenariosPlaceholder}
                      </Typography>
                    );
                  }

                  return selected;
                }}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Without label" }}
              >
                {industry.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, scenario, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
              {!isSelectedScenario && (
                <FormHelperText css={errorWrapper} error={!isSelectedScenario}>
                  请选择应用场景
                </FormHelperText>
              )}
            </Box>
            <Box>
              <Select
                displayEmpty
                value={product}
                size="small"
                onChange={handleProductChange}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <Typography>
                        {testDriveInfo?.productPlaceholder}
                      </Typography>
                    );
                  }

                  return selected;
                }}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Without label" }}
              >
                {products?.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    style={getStyles(name, product, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
              {!isSelectedProduct && (
                <FormHelperText css={errorWrapper} error={!isSelectedProduct}>
                  请选择产品
                </FormHelperText>
              )}
            </Box>
          </Box>
          <Select
            displayEmpty
            value={city}
            size="small"
            onChange={handleCityChange}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <Typography>
                    {city || testDriveInfo?.cityPlaceholder}
                  </Typography>
                );
              }

              return selected;
            }}
            MenuProps={MenuProps}
            inputProps={{ "aria-label": "Without label" }}
          >
            {allCities.map((name) => (
              <MenuItem
                key={name}
                value={name}
                style={getStyles(name, city, theme)}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
          {!isSelectedCity && (
            <FormHelperText css={errorWrapper} error={!isSelectedCity}>
              请选择城市
            </FormHelperText>
          )}
          <FormControl>
            <RadioGroup
              css={() => cityRadio(isSelectedCity)}
              defaultValue="nearest"
              name="radio-buttons-group"
            >
              <FormControlLabel
                value="nearest"
                control={<Radio color="default" />}
                label="距离优先"
                labelPlacement="start"
              />
            </RadioGroup>
          </FormControl>

          <Select
            displayEmpty
            value={dealer}
            size="small"
            onChange={handleDealerChange}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <Typography>{testDriveInfo?.dealerPlaceholder}</Typography>
                );
              }

              return selected;
            }}
            css={dealerWrapper}
            MenuProps={MenuProps}
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem disabled value="">
              <Typography style={{ fontSize: "10px" }}>
                {currentCityDealers.length ? "选择经销商" : "未查询到经销商"}
              </Typography>
            </MenuItem>
            {currentCityDealers.map((item) => (
              <MenuItem
                key={item?.attributes?.title}
                value={item?.attributes?.title}
                style={getStyles(item?.attributes?.title, dealer, theme)}
                css={dealerListItemWrapper}
              >
                <Box>
                  <Typography>{item?.attributes?.title}</Typography>
                  {isAllowPosition && (
                    <Typography>{item?.attributes.distance}km</Typography>
                  )}
                </Box>
                <Box css={categoryWrapper}>
                  {item?.attributes?.dealer_categories?.data?.map(
                    (category) => (
                      <div css={functionality} key={v4()}>
                        <Typography>{category?.attributes?.name}</Typography>
                      </div>
                    )
                  )}
                </Box>
              </MenuItem>
            ))}
          </Select>
          <Box css={() => privacyPolicyWrapper(isCheckedApprovePolicy)}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={approvePolicy}
                  onChange={() => setApprovePolicy(!approvePolicy)}
                  name="Privacy policy"
                />
              }
              label={testDriveInfo?.readAndAcceptText}
            />
            <Typography css={privacyPolicy} onClick={() => setModalOpen(true)}>
              {testDriveInfo?.privacyPolicy}
            </Typography>
            <Box>
              <BootstrapDialog
                onClose={() => setModalOpen(false)}
                aria-labelledby="customized-dialog-title"
                open={modalOpen}
              >
                <BootstrapDialogTitle
                  id="customized-dialog-title"
                  onClose={() => setModalOpen(false)}
                >
                  {testDriveInfo?.privacyPolicyModalTitle}
                </BootstrapDialogTitle>
                <DialogContent dividers css={privacyPolicyContentWrapper}>
                  <Markdown>
                    {(process.env.REACT_APP_BASEURL.includes("localhost")
                      ? testDriveInfo?.privacyPolicyModalContent?.replaceAll(
                          "/uploads/",
                          `${process.env.REACT_APP_BASEURL}/uploads/`
                        )
                      : testDriveInfo?.privacyPolicyModalContent) || ""}
                  </Markdown>
                </DialogContent>
              </BootstrapDialog>
            </Box>
          </Box>
          <Button variant="contained" onClick={handleSubmit}>
            {testDriveInfo?.submitText}
            {isLoading && (
              <CircularProgress
                color="inherit"
                style={{ width: "20px", height: "20px", marginLeft: "5px" }}
              />
            )}
          </Button>
        </Box>
      )}
    </Box>
  );
};
const AppointmentResult = ({
  reservationSuccessTitle,
  reservationSuccessContent,
  backToHomeText,
  reservationFailureTitle,
  backText,
  isAppointmentSuccess,
  setIsAppointmentSubmit,
}) => (
  <Box css={appointmentSuccessWrapper}>
    {isAppointmentSuccess ? (
      <Box>
        <Typography>{reservationSuccessTitle}</Typography>
        <Typography></Typography>
        <Typography>{reservationSuccessContent}</Typography>
        <div>
          <Link to="/">
            <Button>{backToHomeText}</Button>
          </Link>
        </div>
      </Box>
    ) : (
      <Box>
        <Typography>{reservationFailureTitle}</Typography>
        <Typography></Typography>
        <Typography>{`抱歉您的预约申请由于网络问题未提交成功，烦请重新提交`}</Typography>
        <div>
          <Button onClick={() => setIsAppointmentSubmit(false)}>
            {backText}
          </Button>
        </div>
      </Box>
    )}
  </Box>
);
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontSize: "36px" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
// const PrivacyPolicyModal = () => {};
const TimeCountdown = ({
  setIsLegalUserTel,
  sendValidationCode,
  token,
  userTel,
}) => {
  const [sec, setSec] = useState(0);
  const timeRef = useRef();
  useEffect(() => {
    if (sec && sec !== 0)
      timeRef.current = setTimeout(() => {
        setSec((sec) => sec - 1);
      }, 1000);
    return () => {
      clearTimeout(timeRef.current);
    };
  }, [sec]);
  const sendVerificationCode = async () => {
    if (/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(userTel)) {
      setSec(60);
      setIsLegalUserTel(true);
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          ...headers,
        },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_JAVAURL}${API_URLS.generateOtp}`,
        { mobile: Base64.encode(userTel) },
        config
      );
      console.log(response);
    } else {
      setIsLegalUserTel(false);
    }
  };
  return (
    <>
      {sec === 0 ? (
        <Typography
          onClick={sendVerificationCode}
          css={verificationText}
          position="end"
        >
          {sendValidationCode}
        </Typography>
      ) : (
        <Typography css={verificationText} position="end">
          {sec}秒后 再次发送
        </Typography>
      )}
    </>
  );
};
export default TestDrive;
